import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import { consolidationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { ConsolidationInventoryItemSchema } from "./consolidation-inventory-item";

const ConsolidationItemCandidateSchema_ =
  ConsolidationInventoryItemSchema.extend({
    availableQuantity: z.number().int(),
    configuredBinAvailableQuantity: z.number().int(),
    dueAt: z.date().nullable(),
    dueByCutoff: z.boolean(),
    inConfiguredConsolidationBin: z.boolean(),
  });

export const ConsolidationItemCandidateSchema: z.ZodType<ConsolidationItemCandidate> =
  ConsolidationItemCandidateSchema_;
export interface ConsolidationItemCandidate extends z.infer<
  typeof ConsolidationItemCandidateSchema_
> {}

export const listConsolidationItemCandidates = {
  name: "listConsolidationItemCandidates" as const,
  input: z.object({
    consolidationId: consolidationIdFormat.schema,
    cursor: inventoryItemIdFormat.schema.optional(),
    pageSize: z.number().int().min(1).max(500).default(100),
  }),
  output: z.object({
    items: z.array(ConsolidationItemCandidateSchema),
    nextCursor: inventoryItemIdFormat.schema.nullable(),
  }),
};
